import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FeaturedPropertiesRoutingModule } from './featured-properties-routing.module';
import { FeaturedPropertiesComponent } from './featured-properties/featured-properties.component';
import { CityFinderComponent } from 'src/app/shared/city-finder/city-finder.component'
import { CityFinderModule } from 'src/app/shared/city-finder/city-finder.module'
@NgModule({
  declarations: [
    FeaturedPropertiesComponent,

  ],
  imports: [
    CommonModule,
    FeaturedPropertiesRoutingModule,
    SharedModule,
  ]
})
export class FeaturedPropertiesModule { }
